import InputSelectGroup from "./TypesOfInputs/InputSelectGroup";
import Select from "./TypesOfInputs/Select";
import Input from "./TypesOfInputs/Input";
import Radio from "./TypesOfInputs/Radio";
import { useSelection } from "../../contexts/SelectionContext";

export default function SelectionForm({
  currentData,
  options,
  changeData,
  onBlur,
  onMeasureChange,
  onBlock,
}) {
  const { currentActiveTab } = useSelection();

  const handleBlur = (name, value, measureValue) => {
    if (onBlur) onBlur(name, value, measureValue);
  };

  const handleInputChange = (field, value) => {
    changeData(field, value);
  };

  const handleMeasureChange = (field, value, measureId, measureValue) => {
    onMeasureChange(field, value, measureId, measureValue);
  };
  const handleFieldChange = (item, value, measureValue) => {
    if (item.type === "inputs-group")
      handleMeasureChange(item.name, value, item.measureId, measureValue);
    else handleInputChange(item.name, value);
  };

  return (
    <div className="form-selection">
      {options[0]?.selectionOptions?.map((item) => {
        // Поле с dependsOn показывается только когда поле-условие равно значению
        if (
          item.dependsOn &&
          currentData[item.dependsOn.field] !== item.dependsOn.value
        )
          return null;

        const commonProps = {
          name: item.name,
          id: item.id,
          required: item.required,
          titleRus: item.titleRus,
          message: item.message,
          restrictions: item.restrictions,
          value: currentData[item.name],
          onBlock: onBlock,
          onChange: (value, measureValue) =>
            handleFieldChange(item, value, measureValue),
          onBlur: (name, value, measureValue) =>
            handleBlur(name, value, measureValue),
        };

        if (
          currentActiveTab === "Default" &&
          (item.id === "pcnt" || item.id === "BoxType")
        )
          return null;
        else {
          switch (item.type) {
            case "select":
              return (
                <Select key={item.id} options={item.options} {...commonProps} />
              );
            case "inputs-group":
              return (
                <InputSelectGroup
                  key={item.id}
                  measureOptions={item.measureOptions}
                  measureId={item.measureId}
                  currentMeasure={currentData[item.measureId]}
                  {...commonProps}
                />
              );
            case "input":
              return <Input key={item.id} {...commonProps} />;
            case "radio":
              return (
                <Radio key={item.id} options={item.options} {...commonProps} />
              );
            default:
              return null;
          }
        }
      })}
    </div>
  );
}
